import { TypePessoa } from "../../Pessoa/Pessoa";
import { TypeUsuario } from "../../Usuario";
import { TypeInscricaoDoAlunoNaViagem } from "../Viagem/InscricaoDoAlunoNaViagem";
import { TypeAlunoEResponsavel } from "./AlunoEResponsavel";
import { EnumTipoDeDocumento } from "./Enum";
import { TypeAlunoENacionalidade } from "./AlunoENacionalidade";
import { TypeFichaDeSaude } from "../Saude/FIcha/FichaDeSaude";

export type TipoDeDocumentoPrincipal = "cpf" | "passaporte" | "rne"

export type TypeAluno = {

    codigo?: number;

    pessoa?: Omit<TypePessoa, "usuario">,
    usuarioDaAreaRestrita?: TypeUsuarioDaAreaRestrita,

    dataDeNascimento?: Date;

    tipoDeDocumento?: EnumTipoDeDocumento;
    documento?: string;
    dataDeExpedicaoDoDocumento?: Date;

    nacionalidades?: TypeAlunoENacionalidade[];

    responsaveis?: TypeAlunoEResponsavel[];

    inscricoes?: TypeInscricaoDoAlunoNaViagem[],

    fichasDeSaude?: TypeFichaDeSaude[],

    ativo?: boolean;
    dataDeCriacao?: Date;

    operador?: TypeUsuario;
}

/** @deprecated Utilizar o metodo com mesmo nome na entidade de Pessoa */
export function extractorNomePessoa(pessoa:TypePessoa) : string {
    return (pessoa.nomeSocial?.length ?? 0) > 0 ? pessoa.nomeSocial! : pessoa.nome!;
}